<template>
  <div>
    <card>
        <table class="table tablesorter" id="tabella" style="text-align: center">
            <thead>
                <tr>
                    <th>Cognome</th>
                    <th>Nome</th>
                    <th>Codice Fiscale</th>
                    <th>Tipo Rappresentante</th>
                    <th>Principale</th>
                </tr>
            </thead>
            <tbody>
                <tr class="row-color">
                    <td>..</td>
                    <td>..</td>
                    <td>..</td>
                    <td>..</td>
                    <td>..</td>
                </tr>
                 <tr class="row-color">
                    <td>..</td>
                    <td>..</td>
                    <td>..</td>
                    <td>..</td>
                    <td>..</td>
                </tr>
            </tbody>
        </table>
    </card>
    <hr>
    <card>
        <h3 style="color:#00467f">Dati Responsabile Antiriciclaggio</h3>
        <hr>
        <form>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="codice_fiscale">Codice Fiscale</label>
                    <input type="text" class="form-control" v-model="codice_fiscale" placeholder="codice_fiscale">
                </div>
                <div class="form-group col-md-4">
                    <label for="p_iva">Partita IVA</label>
                    <input type="text" class="form-control" v-model="p_iva" placeholder="p_iva">
                </div>
                <div class="form-group col-md-4">
                    <label for="denominazione">Denominazione</label>
                    <input type="text" class="form-control" v-model="denominazione" placeholder="denominazione">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="data_fine_incarico">Data fine incarico</label>
                    <input type="date" class="form-control" v-model="data_fine_incarico" placeholder="data_fine_incarico">
                </div>
                <div class="form-group col-md-4">
                    <label for="tipo_soggetto">Tipo Soggetto</label>
                    <input type="text" class="form-control" v-model="tipo_soggetto" placeholder="tipo_soggetto">
                </div>
                <div class="form-group col-md-4">
                    <label for="telefono">Telefono</label>
                    <input type="text" class="form-control" v-model="telefono" placeholder="telefono">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="fax">Fax</label>
                    <input type="text" class="form-control" v-model="fax" placeholder="fax">
                </div>
                <div class="form-group col-md-6">
                    <label for="indirizzo_email">Indirizzo Email</label>
                    <input type="text" class="form-control" v-model="indirizzo_email" placeholder="indirizzo_email">
                </div>
            </div>
        </form>
        <button class="btn float-right" type="button" v-on:click="salvaValoriResponsabile()" style="margin-top: 10px;background:#00467f">Salva</button>
        
        <h3 style="margin-top:20px;color:#00467f">Domicilio Professionale</h3>
        <hr>
        <form>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="indirizzo_residenza">Indirizzo</label>
                    <input type="text" class="form-control" v-model="indirizzo_residenza" placeholder="indirizzo_residenza">
                </div>
                <div class="form-group col-md-4">
                    <label for="comune_residenza">Comune</label>
                    <input type="text" class="form-control" v-model="comune_residenza" placeholder="comune_residenza">
                </div>
                <div class="form-group col-md-4">
                    <label for="provincia_residenza">Provincia</label>
                    <input type="text" class="form-control" v-model="provincia_residenza" placeholder="provincia_residenza">
                </div>
            </div>
        </form>
        <button class="btn float-right" type="button" v-on:click="salvaValoriDomicilio()" style="margin-top: 10px;background:#00467f">Salva</button>
        
        <h3 style="margin-top:20px;color:#00467f">Soggetti Rappresentanti</h3>
        <hr>
        <form>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="cognome">Cognome</label>
                    <input type="text" class="form-control" v-model="cognome" placeholder="cognome">
                </div>
                <div class="form-group col-md-4">
                    <label for="nome">Nome</label>
                    <input type="text" class="form-control" v-model="nome">
                </div>
                <div class="form-group col-md-4">
                    <label for="codice_fiscale_sogg">Codice Fiscale</label>
                    <input type="text" class="form-control" v-model="codice_fiscale_sogg">
                </div>
                <div class="form-group col-md-4">
                    <label for="numero_documento">Tipo Rappresentante</label>
                    <select v-model="tipo_rappresentante" class="form-control">
                        <option>..</option>
                        <option>..</option>
                    </select>
                </div>
            </div>
            
        </form>
        <button class="btn float-right" type="button" v-on:click="salvaValoriSoggettoRappresentanti()" style="margin-top: 10px;background:#00467f">Salva</button>
       
    </card>
  </div>
</template>
<script>
import Card from "@/components/Cards/Card.vue";
export default {
    components: {
        Card
    },

    data() {
        return {
            // DATI RESPONSABILE ANTIRICICLAGGIO
            codice_fiscale: null,
            p_iva: null,
            denominazione: null, 
            data_fine_incarico: null,
            tipo_soggetto: null,
            telefono: null,   
            fax: null,
            indirizzo_email: null, 
            // DOMICILIO PROFESSIONALE
            indirizzo_residenza: null, 
            comune_residenza: null,
            provincia_residenza: null,
            // SOGGETTO RAPPRESENTANTI
            cognome: null, 
            nome: null, 
            codice_fiscale_sogg: null, 
            tipo_rappresentante: null,
        }
    },
    computed: {},

    methods: {
        salvaValoriResponsabile: async function() {
            let dati = [{ CF: this.codice_fiscale, P_IVA: this.p_iva, DENOMINAZIONE: this.denominazione, DATA_FINE_INCARICO: this.data_fine_incarico, TIPO_SOGGETTO: this.tipo_soggetto, TELEFONO: this.telefono, FAX: this.fax, INDIRIZZO_EMAIL: this.indirizzo_email }]
            /*
            let salvaValori = [];
            await axios.post(
                this.urlRichieste + '', dati,
                withCredentials: true,
                headers: {
                    "Content-type": "application/json",
                    'Authorization': `Bearer ${token}`
                }
            )   
            .then(response => { salvaValori= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                errore = error.response.status;
                }
            });
            */
       },

       salvaValoriDomicilio: async function() {
           let dati = [{  INDIRIZZO_RESIDENZA: this.indirizzo_residenza, COMUNE_RESIDENZA: this.comune_residenza, PROVINCIA_RESIDENZA: this.provincia_residenza,}]
          /*
            let salvaValori = [];
            await axios.post(
                this.urlRichieste + '', dati,
                withCredentials: true,
                headers: {
                    "Content-type": "application/json",
                    'Authorization': `Bearer ${token}`
                }
            )   
            .then(response => { salvaValori= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                errore = error.response.status;
                }
            });
             */
       },

        salvaValoriSoggettoRappresentanti: async function() {
            let dati = [{ COGNOME: this.cognome, NOME: this.nome, CF: this.codice_fiscale_sogg, TIPO_RAPPRESENTANTE: this.tipo_rappresentante }]
            /*
             let salvaValori = [];
            await axios.post(
                this.urlRichieste + '', dati,
                withCredentials: true,
                headers: {
                    "Content-type": "application/json",
                    'Authorization': `Bearer ${token}`
                }
            )   
            .then(response => { salvaValori= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                errore = error.response.status;
                }
            });
             */
        },
    

        main: function() {
            this.caricaSoggetti();
        },
    },
    
    mounted() {
        this.main();
    } 

};
</script>
<style>
.row-color:hover {
  background-color: #00467f53;
}
</style>
